require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./articles-financial-center-recognized-as-a-2024-best-place-to-work-in-indiana.json") })
        }
      }, "path---articles-financial-center-recognized-as-a-2024-best-place-to-work-in-indiana");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---articles-financial-center-recognized-as-a-2024-best-place-to-work-in-indiana!./.cache/json/articles-financial-center-recognized-as-a-2024-best-place-to-work-in-indiana.json
// module id = 1669
// module chunks = 231608221292675